



































import { defineComponent } from "@vue/composition-api";
import { isImageFile, isMediaFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { PostFileData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseCloser from "@/components/BaseCloser";
import BaseIcon from "@/components/BaseIcon";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import FileImageView from "./components/FileImageView";
import MediaImageView from "./components/MediaImageView";
import PreviewSetButton from "../PreviewSetButton";

export default defineComponent({
  name: "PostFileThumbnail",
  components: { PreviewSetButton, LoadingThumbnail, BaseCloser, BaseIcon, BaseButton, MediaImageView, FileImageView },
  props: {
    postFile: { type: Object as () => PostFileData, required: true },
    removable: { type: Boolean, default: true },
    showPublicButton: { type: Boolean, default: false },
  },
  computed: {
    processingError(): boolean {
      return this.postFile.processingStatus === "ERROR";
    },
    isPublic(): boolean {
      return this.postFile.public;
    },
    icon(): string {
      if (isVideoFile(this.postFile)) return "sci-video";
      return "sci-image";
    },
    src(): string {
      if (!this.postFile.url) return "";
      if (isVideoFile(this.postFile)) return MediaFilesController.getVideoThumbnail(this.postFile.url, "480p");
      if (isImageFile(this.postFile)) return MediaFilesController.getImageThumbnail(this.postFile.url, "480p");
      return "";
    },
    duration(): string {
      if (this.postFile.duration) return getMediaDuration(this.postFile.duration);
      return "";
    },
    isMedia(): boolean {
      return isMediaFile(this.postFile);
    },
  },
});
